/* eslint-disable indent */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import BodyText from './ArticleModules/BodyText/BodyText';
import Byline from './Byline';
import ArticleHeader from './ArticleHeader';
import './article-styles-pw.scss';
import { getFileName, isValid } from '../../utils';
import { AUTHOR_IMAGE_PLACEHOLDER } from '../../consts';

const GuideArticleMobile = ({
    data, article, isRoster, isGuide, isMobile, isAffiliate, articleLayout,
}) => {
    const {
        type,
        headline,
        publishData,
        author,
        text,
        category,
        subcategory,
        heroImage,
        byline_display,
        tags,
        seo,
        settings,
        social,
        sponsorship,
    } = data;
    if (!isValid(data)) {
        return null;
    }
    let authorImg;
    let authorImgAlt;
    let authorLink;
    let authorTwitter;
    let authorInstagram;
    let categoryText;
    if (!isValid(social) || !isValid(seo)) {
        authorTwitter = 'https://twitter.com/purewow';
        authorInstagram = 'https://www.instagram.com/purewow/';
        authorImg = AUTHOR_IMAGE_PLACEHOLDER;
        authorImgAlt = getFileName(authorImg);
        authorLink = '';
        categoryText = 'The Roster';
      } else {
        authorTwitter = isValid(author.twitter) ? author.twitter : 'https://twitter.com/purewow';
        authorInstagram = isValid(author.insta) ? author.insta : 'https://www.instagram.com/purewow/';
        authorImg = isValid(author.image) ? author.image : AUTHOR_IMAGE_PLACEHOLDER;
        authorImgAlt = getFileName(authorImg);
        authorLink = `/author/${author.link}`;
        categoryText = category;
      }

    return (
        <div className="guide-article-container">
            <div className="text-wrapper">
                <Fragment>
                    <ArticleHeader
                        category={category}
                        subcategory={subcategory}
                        categoryText={categoryText}
                        tags={tags}
                        display={byline_display}
                        article={article}
                        isRoster={isRoster}
                        isGuide={isGuide}
                        isMobile={isMobile}
                        authorTwitter={authorTwitter}
                        authorInstagram={authorInstagram}
                    />
                    <Byline
                        imgURL={authorImg}
                        imgAlt={authorImgAlt}
                        name={author.name}
                        link={authorLink}
                        nameTwitter={authorTwitter}
                        nameInstagram={authorInstagram}
                        pubData={publishData}
                        sponsorship={sponsorship}
                        tags={tags}
                        taggedSlugs={byline_display.taggedSlugs}
                        showEditorByline={author.shouldShow}
                        articleType={type}
                        secondAuthorName={author.secondAuthorName}
                        secondAuthorText={author.secondAuthorText}
                        secondAuthorUrl={author.secondAuthorUrl}
                        display={byline_display}
                        isMobile={isMobile}
                    />
                    {isValid(text)
                        && <BodyText className="body-text" data={text} isAffiliate={isAffiliate} articleLayout={articleLayout}/>
                    }
                </Fragment>
            </div>
        </div>
        );
};

GuideArticleMobile.PropTypes = {
  className: PropTypes.string,

};

export default GuideArticleMobile;
